import React from 'react'
import { Progress } from 'antd'

export const TankFillBar = ({
  fill,
  projectedFill = fill,
  showWarning,
  lowThreshold,
  showInfo = false,
  successColor = '#64d28d',
  ...others
}) => {
  const className = showWarning ? 'low-volume' : ''

  return (
    <span className={className}>
      <Progress
        success={{ percent: Math.round(fill * 100), strokeColor: successColor }}
        percent={Math.round(projectedFill * 100)}
        className={className}
        showInfo={showInfo}
        {...others}
      />
    </span>
  )
}
